import { render, staticRenderFns } from "./Wechatapps.vue?vue&type=template&id=2f0fd4ce&scoped=true"
import script from "./Wechatapps.vue?vue&type=script&lang=js"
export * from "./Wechatapps.vue?vue&type=script&lang=js"
import style0 from "./Wechatapps.vue?vue&type=style&index=0&id=2f0fd4ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0fd4ce",
  null
  
)

export default component.exports